// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__2akam","disabled":"FileBtn_disabled__2y-sH","warn":"FileBtn_warn__1H9b8","fade":"FileBtn_fade__39i1X"};